import { CAPABILITIES, capabilityLabel } from '@/constants/capabilities'
import { useSubscription } from '@/composables/useSubscription'

/**
 * Route gate: pages declare meta.requiredCapability.
 * Missing capability → FeatureLocked screen (protected page is not mounted).
 */
export default defineNuxtRouteMiddleware(async to => {
  const required = to.meta.requiredCapability as string | undefined
  if (!required)
    return

  // Public / system routes should not declare requiredCapability.
  if (to.meta.public || to.meta.systemContext)
    return

  const { ensureLoaded, hasCapability, subscriptionLoading } = useSubscription()

  try {
    await ensureLoaded()
  }
  catch (e) {
    console.error('subscription ensureLoaded failed', e)
  }

  if (subscriptionLoading.value)
    await ensureLoaded()

  if (hasCapability(required))
    return

  return navigateTo({
    path: '/feature-locked',
    query: {
      capability: required,
      from: to.fullPath,
      title: capabilityLabel(required),
    },
    replace: true,
  })
})

// Re-export for discoverability in page meta docs
export { CAPABILITIES }
